import axios from "axios"
import { API_BASE_URL } from "../config"

export type MedicalRecordSensitivityRequest = {
  sensitivity_enabled?: number | null
  sensitivity?: number | null
  detection_enabled?: number | null
  detection_period_start?: string | null
  detection_period_end?: string | null
  option_enabled?: number | null
  option_period_start?: string | null
  option_period_end?: string | null
}

export const manageMedicalRecordCreate = async (
  facility_id: string,
  room_no: string,
  name: string,
  initial: string,
  birthday: number,
  phone: string,
  is_poc: boolean,
  device_1: string | null,
  device_2: string | null,
  device_3: string | null,
  device_4: string | null,
  device_5: string | null,
  device_6: string | null,
  device_7: string | null,
  device_8: string | null,
  device_9: string | null,
  device_10: string | null,
  device_place_1: string | null,
  device_place_2: string | null,
  device_place_3: string | null,
  device_place_4: string | null,
  device_place_5: string | null,
  device_place_6: string | null,
  device_place_7: string | null,
  device_place_8: string | null,
  device_place_9: string | null,
  device_place_10: string | null,
  sensitivitySetting?: MedicalRecordSensitivityRequest
) => {
  const requestData: any = {
    session_code: localStorage.getItem("session_code"),
    facility_id: facility_id,
    room_no: room_no,
    name: name,
    initial: initial,
    birthday: birthday,
    phone: phone,
    is_poc: is_poc
  }

  if (device_1) requestData.device_1 = device_1
  if (device_2) requestData.device_2 = device_2
  if (device_3) requestData.device_3 = device_3
  if (device_4) requestData.device_4 = device_4
  if (device_5) requestData.device_5 = device_5
  if (device_6) requestData.device_6 = device_6
  if (device_7) requestData.device_7 = device_7
  if (device_8) requestData.device_8 = device_8
  if (device_9) requestData.device_9 = device_9
  if (device_10) requestData.device_10 = device_10

  if (device_place_1) requestData.device_place_1 = device_place_1
  if (device_place_2) requestData.device_place_2 = device_place_2
  if (device_place_3) requestData.device_place_3 = device_place_3
  if (device_place_4) requestData.device_place_4 = device_place_4
  if (device_place_5) requestData.device_place_5 = device_place_5
  if (device_place_6) requestData.device_place_6 = device_place_6
  if (device_place_7) requestData.device_place_7 = device_place_7
  if (device_place_8) requestData.device_place_8 = device_place_8
  if (device_place_9) requestData.device_place_9 = device_place_9
  if (device_place_10) requestData.device_place_10 = device_place_10

  if (sensitivitySetting) {
    if (sensitivitySetting.sensitivity_enabled !== undefined && sensitivitySetting.sensitivity_enabled !== null) {
      requestData.sensitivity_enabled = sensitivitySetting.sensitivity_enabled
    }
    if (sensitivitySetting.sensitivity !== undefined && sensitivitySetting.sensitivity !== null) {
      requestData.sensitivity = sensitivitySetting.sensitivity
    }
    if (sensitivitySetting.detection_enabled !== undefined && sensitivitySetting.detection_enabled !== null) {
      requestData.detection_enabled = sensitivitySetting.detection_enabled
    }
    if (sensitivitySetting.detection_period_start) {
      requestData.detection_period_start = sensitivitySetting.detection_period_start
    }
    if (sensitivitySetting.detection_period_end) {
      requestData.detection_period_end = sensitivitySetting.detection_period_end
    }
    if (sensitivitySetting.option_enabled !== undefined && sensitivitySetting.option_enabled !== null) {
      requestData.option_enabled = sensitivitySetting.option_enabled
    }
    if (sensitivitySetting.option_period_start) {
      requestData.option_period_start = sensitivitySetting.option_period_start
    }
    if (sensitivitySetting.option_period_end) {
      requestData.option_period_end = sensitivitySetting.option_period_end
    }
  }

  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/medical_record/create`, requestData)

      if (response.data.session_code) {
        localStorage.setItem("session_code", response.data.session_code)
      }
      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
